import moment from "moment";
export const searchTaskList = (search,taskList) => {
    let list=[...taskList]
    let searchData = list.filter(row => {
        return row.companyName.toLowerCase().includes(search)
        // row.comapanyName.includes(search)
    })
    return searchData
}

export function hasETACrossed(dueDateStr) {
    let dueDate = moment(dueDateStr);
    let currentDate = moment();
    let diffDays = dueDate.diff(currentDate, 'days');
    if (diffDays < 3) {
        return true;
    }
    else
        return false;
}